// extracted by mini-css-extract-plugin
module.exports = {"hero-section":"styles_hero-section__wUDVB"};